import React, { useState, useEffect } from "react";
import logo from "../assets/imgs/logo.png";
import dashboardIcon from "../assets/imgs/icons/dashboard icon.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile screen
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Toggle the mobile menu
  const toggleMenu = () => setMenuOpen(!menuOpen);

  // Close menu after clicking a link (only on mobile)
  const handleLinkClick = () => {
    if (isMobile) setMenuOpen(false);
  };

  return (
    <>
      {/* Dashboard icon for mobile */}
      {isMobile && (
        <div className="mobile-dashboard-icon" onClick={toggleMenu}>
          <img src={dashboardIcon} alt="Menu" />
        </div>
      )}

      {/* Header */}
      <header className={`${isMobile ? (menuOpen ? "show-header" : "hide-header") : ""}`}>
        <nav>
          <ul>
            <a href="#home" onClick={handleLinkClick}>HOME</a>
            <a href="#about" onClick={handleLinkClick}>ABOUT</a>
            <a href="#awards" onClick={handleLinkClick}>AWARDS</a>
            <a href="#team" onClick={handleLinkClick}>TEAM</a>
            <a href="#contact" onClick={handleLinkClick}>CONTACT</a>
            <img className="logo" src={logo} alt="logo" />
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Header;